<template>
    <div class="layout">
        <v-container fluid style="z-index: 1;">
            404
        </v-container>
         <x-particles id="myParticles" class="particles-background" :config="config"></x-particles>
    </div>
</template>
<script>
import defConfig from '../assets/particlesConfig.js'
export default {
    name: "Page404",
    data() {
        return {
            config: {}
        }
    },
    created() {
        this.config = defConfig
    }
}
</script>
<style scoped>
.particles-background {
    background: #424242;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;

    
}
.layout {
    text-align: center;
    background: transparent;
    
}
</style>